import _ from 'lodash';
import React from 'react';
import ReactDom from 'react-dom';
import {connect} from 'react-redux';
import styles from './css/GuestBook.styl';
import CondolenceItem from './CondolenceItem';
import CondolenceCollection from './CondolenceCollection';
import ThankYou from './ThankYou';
import Entry from './CondolenceEntry';
import EntryNav from './EntryNav';
import CaptionContainer from './CaptionContainer';
import {
  Audio,
  FormControls,
  Modal,
  Spinner,
  Video,
} from '../../../../shared/library';
import ErrorDisplay from '../../../../shared/ErrorDisplay';
import {
  bindMethods,
  setRef,
} from '../../../../shared/utilities/componentHelpers';
import {MEDIA_TYPES} from '../../../../shared/utilities/constants';
import * as CONSTANTS from '../../../../shared/utilities/constants';
import {getGATags} from '../../../../shared/utilities/GAHelpers';
import {scrollToTop} from '../../../../shared/utilities/scrollHelpers';
import {updateHistory} from '../../../../shared/utilities/urlHelpers';
import {mutatePersonAlert} from '../../../../redux/personAlertHelper';
import {
  queryCondolences,
  queryGalleryCondolences,
  mutateCondolence,
  resetCondlenceMutationStatus,
} from '../../../../redux/condolenceHelper';

const {Button} = FormControls;
const {ENTRY_KEY} = CONSTANTS;
const VIDEO_MODAL_PADDING = 12;

/**
 * GuestBook page module.
 * @class   GuestBook
 * @prop    {Object}  person - An obituary with a list of condolences
 * @return  {JSX}     Returns the rendered module
 */
export class GuestBook extends React.Component {
  static propTypes = {
    ads: React.PropTypes.object.isRequired,
    allowGallery: React.PropTypes.bool,
    canonicalUrl: React.PropTypes.string,
    queryCondolences: React.PropTypes.func,
    queryGalleryCondolences: React.PropTypes.func,
    flowersLink: React.PropTypes.string,
    flowersLocation: React.PropTypes.object,
    fpData: React.PropTypes.object,
    galleryConfig: React.PropTypes.object,
    handleModalClose: React.PropTypes.func,
    handleModalOpen: React.PropTypes.func,
    isInferiorBrowser: React.PropTypes.bool,
    location: React.PropTypes.object,
    mobileDetails: React.PropTypes.object.isRequired,
    mutateCondolence: React.PropTypes.func,
    mutatePersonAlert: React.PropTypes.func,
    personStore: React.PropTypes.object,
    primaryFuneralHome: React.PropTypes.object,
    resetMutationStatus: React.PropTypes.func,
    thankYouFlowerClickEvents: React.PropTypes.func,
    title: React.PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      captionsOverlayCount: 0,
      condolenceEntry: {},
      condolenceCount: 9,
      currentOverlayID: null,
      fetchingData: false,
      galleryItemModalIndex: 0,
      hubItemModalIndex: 0,
      isCandleLit: false,
      isExpanded: false,
      isInitialUpload: false,
      isPhone: false,
      mediaCollection: null,
      scrollPosition: null,
      pendingUpload: false,
      showAudioOverlay: false,
      showCaptionsOverlay: false,
      showGallery: false,
      showOverlay: false,
      showThankYou: false,
      showVideoOverlay: false,
      submittingCondolence: false,
      condolenceError: false,
    };

    this.currentPage = 1;
    this.resizeHeight = false;
    this.resizeWidth = false;
    this.element = null;
    this.pid = _.get(props, 'personStore.person.personId');
    this.pageLayout = _.get(
      props,
      'personStore.person.personLayout.layout.left[0]',
      'Obit'
    );
    this.allowGuestBook = _.get(
      props,
      'personStore.person.guestBook.allowGuestBook'
    );
    this.showFlowers =
      _.get(
        props,
        'personStore.person.personLayout.showFlowersAndGifts',
        true
      ) && _.get(props, 'personStore.person.personLayout.fhShowFlowers', true);

    this.submissionData = {
      firstName: '',
      lastName: '',
    };

    /* refs */
    this[ENTRY_KEY] = null;
    this.setRefEntry = _.partial(setRef, _, ENTRY_KEY, this);

    bindMethods(this, [
      'getAdditionalPayload',
      'getAdditionalGalleryPayload',
      'handleCondolenceSubmission',
      'handleDisplayError',
      'handleCondolenceSubmitSuccess',
      'handleEntryToggle',
      'handleMediaCollection',
      'handleGuestBookClick',
      'handleModalClose',
      'handleModalOpen',
      'handleModalResize',
      'handleModalVideoResize',
      'handlePendingUpload',
      'openEditOverlay',
      'handleSetGalleryModalIndex',
      'handleSetItemModalIndex',
      'openCondolenceEntry',
      'toggleCandleLighting',
      'updateModalHeight',
    ]);
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      const galleryCondolences = _.get(
        this.props,
        'personStore.person.guestBookGallery'
      );
      const mediaCount = _.get(
        this.props,
        'personStore.person.guestBook.totalMediaCount',
        0
      );

      this.element = this.props.isInferiorBrowser
        ? document.documentElement
        : document.body;
      window.addEventListener(
        'orientationchangeend',
        this.handleModalVideoResize
      );

      updateHistory(
        window,
        this.props.location,
        this.pageLayout,
        this.allowGuestBook,
        this.pid
      );

      if (this.props.allowGallery && mediaCount !== 0) {
        if (galleryCondolences) {
          let currentMediaCount = _.get(
            galleryCondolences,
            'condolences.edges',
            []
          ).length;
          const outsideMediaCount = _.reduce(
            _.get(galleryCondolences, 'condolences.edges', []).slice(0, 3),
            (total, item) =>
              total + (_.get(item, 'node.isNonCondolenceMedia', false) ? 1 : 0),
            0
          );

          currentMediaCount -= outsideMediaCount;
          if (currentMediaCount < mediaCount && currentMediaCount < 8) {
            this.getAdditionalGalleryPayload();
          }
        } else {
          this.getAdditionalGalleryPayload();
        }
      }
      this.detectIsPhone();
    }
  }

  componentWillReceiveProps(nextProps) {
    const stateObj = {};

    if (_.get(nextProps, 'galleryConfig.show', false)) {
      stateObj.showGallery = nextProps.galleryConfig.show;
      stateObj.galleryItemModalIndex = this.props.galleryConfig.initialId || this.props.galleryConfig.initialId === 0 ? this.state.galleryItemModalIndex : nextProps.galleryConfig.initialId;
    }

    /* fetching additional condolences */
    if (!nextProps.personStore.loading && this.state.fetchingData) {
      stateObj.fetchingData = false;
    }

    if (!_.isEmpty(stateObj)) {
      this.setState(stateObj);
    }

    const currentCondolences = _.get(
      nextProps,
      'personStore.person.guestBook.condolences.edges'
    );
    const nextCondolences = _.get(
      this.props,
      'personStore.person.guestBook.condolences.edges'
    );

    if (_.size(currentCondolences) > _.size(nextCondolences)) {
      this.currentPage++;
    }
    const condolenceMutationStatus = _.get(
      nextProps,
      'personStore.mutationStatus.condolence'
    );

    /* condolence submission handlers */
    if (_.isNumber(condolenceMutationStatus)) {
      this.handlePendingUpload(false, null);
      if (condolenceMutationStatus > 0) {
        this.handleCondolenceSubmitSuccess(
          _.get(this.submissionData, 'firstName', ''),
          _.get(this.submissionData, 'lastName', '')
        );
      } else {
        this.handleDisplayError('submission');
      }
      this.props.resetMutationStatus(condolenceMutationStatus);
    }
  }

  componentWillUnmount() {
    window.removeEventListener(
      'orientationchangeend',
      this.handleModalVideoResize
    );
  }

  /**
   * Phone detection that gets run after component mounts
   * NOTE: This should be removed after the desktop design catches up to the phone design - this is a temporary fixe
   *   to bypass a warning where server rendering did not match client rendering
   * @return {Undefined} Returns nothing
   */
  detectIsPhone() {
    const isPhone = this.props.mobileDetails.phone;

    if (isPhone === true) {
      this.setState({isPhone});
    }
  }

  /**
   * Handles infinite scrolling by setting count
   * @method getAdditionalPayload
   * @param  {Number} currentPage     The current page
   * @return {Undefined} Returns nothing
   */
  getAdditionalPayload(currentPage) {
    if (!this.state.fetchingData) {
      const queryParams = {
        sourceId: _.get(this.props, 'personStore.person.sourceId'),
        count: 9,
        cursor: _.get(
          this.props,
          'personStore.person.guestBook.condolences.pageInfo.endCursor'
        ),
      };

      if (queryParams.sourceId && queryParams.cursor) {
        this.props.queryCondolences(queryParams);
      }

      const dataLayer = window.dataLayer;
      const nextPage = currentPage + 1;

      updateHistory(
        window,
        this.props.location,
        this.pageLayout,
        this.allowGuestBook,
        this.pid,
        nextPage
      );

      // Virtual Page View Tracking
      if (dataLayer) {
        const pathName = _.get(window, 'location.pathname', '');
        const pathQuery = _.get(window, 'location.search', '');

        window.dataLayer.push({
          event: 'analyticsVPV',
          vpvName: `${pathName}${pathQuery}`,
        });
      }
    }
    this.setState({fetchingData: true});
  }

  /**
   * Handles infinite gallery scrolling by setting count
   * @param   {Number} count count value
   * @return  {Undefined} Returns nothing
   */
  getAdditionalGalleryPayload(count = 9) {
    const queryParams = {
      sourceId: _.get(this.props, 'personStore.person.sourceId'),
      count,
      cursor: _.get(
        this.props,
        'personStore.person.guestBookGallery.condolences.pageInfo.endCursor'
      ),
    };

    if (queryParams.sourceId) {
      this.props.queryGalleryCondolences(queryParams);
    }
  }

  /**
   * Handler for closing the modal
   * @param {String} key The key of the modal to close
   * @return {Undefined} Returns nothing
   */
  handleModalClose(key) {
    const stateObj = {};

    stateObj[key] = false;

    if (key === 'showOverlay') {
      stateObj.currentOverlayID = null;
    }
    this.setState(stateObj, () => {
      const element =
        key === 'showThankYou'
          ? this.refs.container
          : ReactDom.findDOMNode(this).querySelector(
              `#HubItem_${this.state.hubItemModalIndex}`
            );

      if (element && key !== 'showGallery') {
        element.focus();
      }

      if (_.isFunction(this.props.handleModalClose)) {
        this.props.handleModalClose(key);
      }
    });
  }

  /**
   * Opens the modal from a hub item
   * @param  {String} id Hub Item id to be shown in the modal
   * @return {Undefined} Returns nothing
   */
  handleModalOpen(id) {
    const condolences = this.props.personStore.person.guestBook.condolences
      .edges;
    const hubItemModalIndex = _.findIndex(condolences, {node: {id}});
    const stateObj = {hubItemModalIndex};

    this.resizeHeight = false;
    this.resizeWidth = false;

    if (this.state.isPhone) {
      const hubItemData = condolences[hubItemModalIndex].node;

      if (_.get(hubItemData, 'video.id')) {
        stateObj.showVideoOverlay = true;
      } else if (hubItemData.audioUrl) {
        stateObj.showAudioOverlay = true;
      } else {
        stateObj.showOverlay = true;
      }
    } else {
      stateObj.showOverlay = true;
      stateObj.currentOverlayID = id;

      getGATags({
        eventCategory: 'bypage_person',
        eventAction: 'browse_condolences',
        eventLabel: 'opened_browse_condolences',
      });
    }

    this.setState(stateObj, () => {
      if (_.isFunction(this.props.handleModalOpen)) {
        this.props.handleModalOpen(id);
      }
    });
  }

  /**
   * Handler for modal navigation
   * @param  {Number} idx Index of the next array item navigated to
   * @param {String} dir The direction that the index was incremented
   * @return {Undefined} Returns nothing
   */
  handleSetItemModalIndex(idx, dir) {
    const indexOffSet = 5;
    const arrayLocation = idx + indexOffSet;
    const condolences = _.get(
      this.props,
      'personStore.person.guestBook.condolences',
      {}
    );
    const hasNextPage = _.get(condolences, 'pageInfo.hasNextPage', false);

    if (
      hasNextPage &&
      arrayLocation === condolences.edges.length &&
      dir === 'next'
    ) {
      this.getAdditionalPayload(this.currentPage);
    }

    getGATags({
      eventCategory: 'bypage_person',
      eventAction: 'browse_condolences',
      eventLabel: dir,
    });

    this.setState({
      currentOverlayID: this.props.personStore.person.guestBook.condolences
        .edges[idx].node.id,
      hubItemModalIndex: idx,
    });
  }

  /**
   * Handler for modal navigation
   * @param  {Number} idx Index of the next array item navigated to
   * @param {String} dir The direction that the index was incremented
   * @return {Undefined} Returns nothing
   */
  handleSetGalleryModalIndex(idx, dir) {
    const indexOffSet = 0;
    const arrayLocation = idx + indexOffSet;
    const condolences = _.get(
      this.props,
      'personStore.person.guestBookGallery.condolences',
      {}
    );
    const hasNextPage = _.get(condolences, 'pageInfo.hasNextPage', false);

    if (
      hasNextPage &&
      arrayLocation + 5 >= condolences.edges.length &&
      dir === 'next'
    ) {
      this.getAdditionalGalleryPayload();
    }

    getGATags({
      eventCategory: 'bypage_person',
      eventAction: 'browse_gallery',
      eventLabel: dir,
    });

    this.setState({
      currentOverlayID: this.props.personStore.person.guestBookGallery
        .condolences.edges[idx].node.id,
      galleryItemModalIndex: idx,
    });
  }

  /**
   * Guestbook click handler
   * @return {Undefined} Returns nothing
   */
  handleGuestBookClick() {
    const offsetTop = this.refs.container.offsetTop;
    const scrollSpeed = 500;

    getGATags({
      eventCategory: 'bypage_person',
      eventAction: 'sign_guest_book_footer',
      eventLabel: 'onpage',
    });

    scrollToTop(this.element, offsetTop, scrollSpeed, this.openCondolenceEntry);
  }

  /**
   * Opens Entry
   * @return {Undefined} Returns nothing
   */
  openCondolenceEntry() {
    this[ENTRY_KEY].handleEntryFocus();
  }

  /**
   * Updates the modal height - used for after videos are uploaded to keep the modal height in sync
   * @return {Undefined} Returns nothing
   */
  updateModalHeight() {
    this.refs.modal.updateHeight();
  }

  /**
   * Get the Max height of a video
   * @return {Number} The max height
   */
  getVideoMaxHeight() {
    return window ? window.innerHeight - VIDEO_MODAL_PADDING : 0;
  }

  /**
   * Handle Modal media resize to keep media elements within full view on phones
   * @return {Undefined} Returns nothing
   */
  handleModalVideoResize() {
    const {videoModalContainer} = this.refs;

    if (this.state.isPhone && videoModalContainer) {
      const ele = videoModalContainer.querySelector('.viddler-app-wrap');
      const eleHeight = ele.clientHeight;
      const modalHeight = this.getVideoMaxHeight();

      if (eleHeight > modalHeight) {
        const width =
          (modalHeight / eleHeight) *
          (videoModalContainer.clientWidth - VIDEO_MODAL_PADDING);

        videoModalContainer.style.width = `${width}px`;
      } else {
        videoModalContainer.style.width = '100%';
      }

      /* triggers the Viddler video to resize */
      window.dispatchEvent(new Event('resize'));
    }
  }

  /**
   * Handler for condolence submission
   * @method handleCondolenceSubmission
   * @param  {object}     submissionData - all non-object type submission data
   * @param  {array}      pictures       - the array of picture objects
   * @param  {object}     personAlert    - the data for the person alert
   * @return {undefined}  returns nothing, calls mutateCondolence or handleDisplayError
   */
  handleCondolenceSubmission(submissionData, pictures, personAlert) {
    const submission = _.cloneDeep(submissionData);

    submission.sourceId = _.get(this.props, 'personStore.person.sourceId');

    if (submission.sourceId) {
      this.handlePendingUpload('Submitting', null);

      submission.iconId = this.state.isCandleLit ? 1 : 0;
      submission.applicationId = this.props.mobileDetails.any ? 65536 : 32768;

      const filteredSubmission = _.reduce(
        submission,
        (result, value, key) => {
          if (value) {
            result[key] = value;
          }
          return result;
        },
        {}
      );

      this.submissionData.firstName = submission.firstName || '';
      this.submissionData.lastName = submission.lastName || '';

      this.props.mutateCondolence({filteredSubmission, pictures});

      if (personAlert) {
        this.props.mutatePersonAlert(personAlert);

        getGATags({
          eventCategory: 'bypage_person',
          eventAction: 'pp_alert',
          eventLabel: 'within_gb_signup',
        });
      }
    } else {
      this.handleDisplayError('submission');
    }
  }

  /**
   * Sets the error state
   * @method handleDisplayError
   * @param  {string} error The display error string
   * @return {undefined} returns nothing, sets state values
   */
  handleDisplayError(error) {
    const errorTypes = {
      submission: 'Oops! There was an error, please submit again.',
      picturesUpload:
        'Oops! There was an error with one or more of your pictures, please try again.',
      picturesUnavailable:
        'Oops! Picture uploads are not available, please submit a text entry.',
      video:
        'Oops! There was an error attempting to upload a video, please try again.',
      invalidEmail: 'Error: Please enter a valid email address.',
      default: 'Oops! There was an error, please try again.',
    };

    if (_.isString(error)) {
      this.setState({
        condolenceError: errorTypes[error] || errorTypes.default,
        submittingCondolence: false,
      });
    } else {
      this.setState({condolenceError: false});
    }
  }

  /**
   * Handle Submission success
   * @param {String} firstName The first name from the entry
   * @param {String} lastName The last name from the entry
   * @return {Undefined} Returns nothing
   */
  handleCondolenceSubmitSuccess(firstName, lastName) {
    this.setState(
      {
        condolenceEntry: {
          firstname: firstName,
          lastname: lastName,
        },
        showThankYou: true,
        submittingCondolence: false,
        condolenceError: false,
        mediaCollection: null,
      },
      () => {
        this[ENTRY_KEY].clearForm();
      }
    );
  }

  /**
   * Handle the modal resizing of media to fit into the viewport
   * @return {Undefined} Returns nothing
   */
  handleModalResize() {
    const {modalHubItemContainer} = this.refs;
    const figure = modalHubItemContainer && modalHubItemContainer.refs.figure;

    if (modalHubItemContainer && figure) {
      const condolences = _.get(
        this.props,
        'personStore.person.guestBook.condolences.edges',
        []
      );
      const hubItemData = _.get(
        condolences,
        '[this.state.hubItemModalIndex].node',
        {}
      );
      const windowHeight = window.innerHeight;
      const eleHeight = figure.clientHeight;
      const eleWidth = figure.clientWidth;
      const IMG_PADDING = 40;

      const height = windowHeight - IMG_PADDING;
      const width = (windowHeight / eleHeight) * eleWidth;

      if (_.get(hubItemData, 'video.id')) {
        this.resizeHeight = false;

        if (eleHeight > windowHeight) {
          this.resizeWidth = true;
        } else if (width > figure.parentElement.clientWidth) {
          this.resizeWidth = false;
        }
      } else if (_.get(hubItemData, 'audioUrl')) {
        this.resizeWidth = false;
        this.resizeHeight = false;
      } else {
        this.resizeWidth = false;

        if (eleHeight > windowHeight) {
          if (figure.querySelector('img')) {
            figure.querySelector('img').style.maxHeight = '100%';
            this.resizeHeight = true;
          }
        } else if (eleHeight - 2 > figure.firstChild.clientHeight) {
          const image = figure.querySelector('img');

          if (image) {
            image.style.maxHeight = 'none';
            this.resizeHeight = false;
          }
        }
      }
      figure.style.width = this.resizeWidth ? `${width}px` : '100%';
      figure.style.height = this.resizeHeight ? `${height}px` : 'auto';

      figure.style.opacity = 1;
    }
  }

  /**
   * Updates the state value when viddler upload starts and stops
   * @method handlePendingUpload
   * @param  {boolean}   shouldDisplay              should the modal show or not
   * @param  {function}  completeFunction  finialize upload
   * @return {undefined} retruns nothing, sets pendingUpload and runs fn
   */
  handlePendingUpload(shouldDisplay, completeFunction) {
    this.setState({pendingUpload: shouldDisplay}, () => {
      if (shouldDisplay && _.isFunction(completeFunction)) {
        completeFunction();
      }
    });
  }

  /**
   * Sets the media collection state value
   * @method handleMediaCollection
   * @param  {Array}      mediaCollection       List of pending media
   * @param  {Boolean}    showCaptionsOverlay   Whether or not to show captions panel
   * @param  {Number}     scrollPosition        Saved scroll position before action
   * @return {Undefined}  Returns nothing
   */
  handleMediaCollection(
    mediaCollection,
    showCaptionsOverlay = false,
    scrollPosition
  ) {
    const captionsOverlayCount =
      _.size(mediaCollection) === 0 ? 0 : this.state.captionsOverlayCount + 1;
    const isInitialUpload = captionsOverlayCount < 2;
    let showOverlay = showCaptionsOverlay;

    if (_.get(mediaCollection, '[0].mediaType') === MEDIA_TYPES.video) {
      this.setState(
        {
          captionsOverlayCount,
          isInitialUpload,
          mediaCollection: mediaCollection || [],
          scrollPosition,
          showCaptionsOverlay,
        },
        () => {
          if (!showOverlay && scrollPosition) {
            scrollToTop(this.element, scrollPosition, 500);
            this.element.style.position = 'static';
            this.element.style.width = 'auto';
          }
        }
      );
    } else {
      const promisedMediaCollection = _.size(mediaCollection)
        ? mediaCollection.map(item => Promise.resolve(item))
        : [];

      Promise.all(promisedMediaCollection)
        .then(mediaItems => {
          const filteredMediaItems = mediaItems.filter(
            item => !_.isEmpty(item)
          );

          showOverlay = showCaptionsOverlay
            ? !_.isEmpty(filteredMediaItems)
            : false;

          this.setState(
            {
              captionsOverlayCount,
              isInitialUpload,
              mediaCollection: filteredMediaItems,
              showCaptionsOverlay: showOverlay,
              scrollPosition,
            },
            () => {
              if (!showOverlay && scrollPosition) {
                scrollToTop(this.element, scrollPosition, 500);
                this.element.style.position = 'static';
                this.element.style.width = 'auto';
              }
            }
          );
        })
        .catch(() => {
          this.handleDisplayError('picturesUpload');
        });
    }
  }

  /**
   * Shows edit overlay and saves current scroll position
   * @return {Undefined}  Returns nothing
   */
  openEditOverlay() {
    const scrollPosition = window.pageYOffset;

    this.element.style.position = 'fixed';
    this.element.style.width = '100%';
    this.setState({
      scrollPosition,
      showCaptionsOverlay: true,
    });
  }

  /**
   * Toggles the candle's state value in order to show or hide the candle.
   * @method  toggleCandleLighting
   * @param   {Boolean}   reset If present sets isCandleLit to false
   * @return  {Undefined} Returns nothing.
   */
  toggleCandleLighting(reset) {
    this.setState({
      isCandleLit: reset === true ? false : !this.state.isCandleLit,
      condolenceError: false,
    });
  }

  handleEntryToggle(isExpanded, setSignupStyle) {
    if (this.state.isExpanded !== isExpanded) {
      this.setState({isExpanded});
    }
    setSignupStyle();
  }

  render() {
    const {
      allowGuestBook,
      allowGuestBookEntry,
      allowPersonPagePosting,
      allowGuestBookPhoto,
      allowGuestBookVideo,
      condolences,
      isFallback,
      totalCondolencesCount,
    } = _.get(this.props, 'personStore.person.guestBook', {});

    const {edges, pageInfo} = condolences || {};
    const gallery =
      _.get(this.props, 'personStore.person.guestBookGallery') || {};
    const hasNextPage = _.get(pageInfo, 'hasNextPage', false);
    const firstName = _.get(this.props, 'personStore.person.name.first');
    const lastName = _.get(this.props, 'personStore.person.name.last');
    const {
      personStore: {person: {personLayout: {personPageType} = {}} = {}} = {},
    } = this.props;

    let preloaderContainer = null;
    let guestBookFooterBtn = null;
    let modal = null;

    if (allowGuestBook) {
      /** Modal Items **/
      const node = _.get(edges, `[${this.state.hubItemModalIndex}].node`, {});
      const {
        audioUrl,
        city,
        date,
        name,
        iconUrl,
        message,
        photo,
        relationship,
        state,
        video,
      } = node;

      /** Gallery Items **/
      const galleryNode = _.get(
        gallery,
        `condolences.edges[${this.state.galleryItemModalIndex}].node`,
        {}
      );

      if (this.state.showOverlay) {
        modal = (
          <Modal
            contentLength={_.size(edges)}
            currentIndex={this.state.hubItemModalIndex}
            getAdditionalPayload={this.getAdditionalPayload}
            handleClose={_.partial(this.handleModalClose, 'showOverlay')}
            handleSetContentIndex={this.handleSetItemModalIndex}
            ref="modal"
            resizeCallback={this.handleModalResize}
          >
            <CondolenceItem
              adService={this.props.ads.adService}
              audioUrl={audioUrl}
              city={city}
              date={date}
              firstName={name && name.firstName}
              iconUrl={iconUrl}
              id={`Modal_${this.state.hubItemModalIndex}`}
              isModal
              lastName={name && name.lastName}
              message={message}
              photo={photo}
              primaryFuneralHome={this.props.primaryFuneralHome}
              ref="modalHubItemContainer"
              relationship={relationship}
              state={state}
              video={video}
              videoReadyCallback={this.updateModalHeight}
            />
          </Modal>
        );
      }

      if (this.state.showGallery) {
        modal = (
          <Modal
            contentLength={_.size(_.get(gallery, 'condolences.edges'))}
            currentIndex={this.state.galleryItemModalIndex}
            getAdditionalPayload={this.getAdditionalGalleryPayload}
            handleClose={_.partial(this.handleModalClose, 'showGallery')}
            handleSetContentIndex={this.handleSetGalleryModalIndex}
            ref="modal"
            resizeCallback={this.handleModalResize}
          >
            <CondolenceItem
              adService={this.props.ads.adService}
              audioUrl={_.get(galleryNode, 'audioUrl')}
              city={_.get(galleryNode, 'city')}
              date={_.get(galleryNode, 'date')}
              firstName={_.get(galleryNode, 'name.firstName')}
              iconUrl={_.get(galleryNode, 'iconUrl')}
              id={`Modal_${this.state.galleryItemModalIndex}`}
              isModal
              lastName={_.get(galleryNode, 'name.lastName')}
              message={_.get(galleryNode, 'message')}
              photo={_.get(galleryNode, 'photo')}
              primaryFuneralHome={this.props.primaryFuneralHome}
              ref="modalHubItemContainer"
              relationship={_.get(galleryNode, 'relationship')}
              state={_.get(galleryNode, 'state')}
              video={_.get(galleryNode, 'video')}
              videoReadyCallback={this.updateModalHeight}
            />
          </Modal>
        );
      }

      if (this.state.showVideoOverlay) {
        modal = (
          <Modal
            classNameCloseBtn={styles.mediaModalCloseBtn}
            classNameContent={styles.mediaModalContent}
            classNameItem={styles.videoModalItem}
            handleClose={_.partial(this.handleModalClose, 'showVideoOverlay')}
            isPhone
          >
            <div
              ref="videoModalContainer"
              style={{margin: '0 auto', width: '100%'}}
            >
              <Video
                id="HubItemModalVideo"
                isPhone
                videoId={video && video.id}
                videoReadyCallback={this.handleModalVideoResize}
              />
            </div>
          </Modal>
        );
      }

      if (this.state.showAudioOverlay) {
        modal = (
          <Modal
            classNameCloseBtn={styles.mediaModalCloseBtn}
            classNameContent={styles.mediaModalContent}
            handleClose={_.partial(this.handleModalClose, 'showAudioOverlay')}
            isPhone
          >
            <div className={styles.audioContainer}>
              <Audio tabIndex="1000" url={audioUrl} />
            </div>
          </Modal>
        );
      }

      if (this.state.showCaptionsOverlay) {
        modal = (
          <Modal
            classNameContent={
              this.props.mobileDetails.any
                ? styles.captionsModalMobileContent
                : null
            }
            isPhone
            showCloseButton={false}
          >
            <CaptionContainer
              handleMediaCollection={this.handleMediaCollection}
              isInitialUpload={this.state.isInitialUpload}
              mediaCollection={this.state.mediaCollection}
              mobileDetails={this.props.mobileDetails}
              scrollPosition={this.state.scrollPosition}
            />
          </Modal>
        );
      }

      if (this.state.pendingUpload) {
        modal = (
          <Modal
            classNameContent={styles.loadingModal}
            handleClose={_.partial(this.handleModalClose, 'pendingUpload')}
            isPhone
            showCloseButton={false}
          >
            <div className={styles.loadingWrapper}>
              <Spinner />
              <p className={styles.loading}>{this.state.pendingUpload}...</p>
            </div>
          </Modal>
        );
      }

      if (this.state.showThankYou) {
        modal = (
          <Modal
            classNameItem={styles.thankYouModal}
            isPhone
            ref="modal"
            showCloseButton={false}
          >
            <ThankYou
              canonicalUrl={this.props.canonicalUrl}
              entry={this.state.condolenceEntry}
              flowerClickEvents={this.props.thankYouFlowerClickEvents}
              flowersLink={this.props.flowersLink}
              flowersLocation={this.props.flowersLocation}
              handleClose={_.partial(this.handleModalClose, 'showThankYou')}
              handleFlowersImgLoad={this.updateModalHeight}
              name={_.get(this.props, 'personStore.person.name')}
              showFlowers={this.showFlowers}
              title={this.props.title}
            />
          </Modal>
        );
      }

      /** Footer Items **/
      if (hasNextPage) {
        if (this.props.personStore.loading) {
          preloaderContainer = (
            <div className={styles.preloader}>
              <Spinner />
            </div>
          );
        }
      } else {
        guestBookFooterBtn =
          totalCondolencesCount > 0 ? (
            <div className={styles.footer}>
              {allowGuestBookEntry &&
              allowPersonPagePosting &&
              _.size(this.state.mediaCollection) === 0 &&
              totalCondolencesCount > 4 ? (
                <Button
                  btnType="primary"
                  className={
                    this.state.isExpanded
                      ? styles.guestBookFooterBtnDisabled
                      : null
                  }
                  disabled={this.state.isExpanded}
                  handleClick={this.handleGuestBookClick}
                  id="SignGuestBookEntryFooter"
                >
                  <span data-ga-no-auto-tag="true">Sign Guest Book </span>
                  <span className={styles.srOnly}>
                    Scrolls to Condolence Entry
                  </span>
                </Button>
              ) : null}
            </div>
          ) : null;
      }

      /** Return the Guestbook **/
      return (
        <div
          className={`${styles.GuestBook}${
            this.state.isPhone ? ` ${styles.phone}` : ''
          }`}
          ref="container"
          tabIndex="0"
        >
          <div className={styles.content}>
            <div className={styles.main}>
              <div className={styles.header}>
                <h2>Guest Book</h2>
                {allowGuestBook && allowGuestBookEntry ? (
                  <EntryNav
                    allowGuestBookPhoto={allowGuestBookPhoto}
                    allowGuestBookVideo={allowGuestBookVideo}
                    fpData={this.props.fpData}
                    handleCandleToggle={this.toggleCandleLighting}
                    handleDisplayError={this.handleDisplayError}
                    handleEditOverlay={this.openEditOverlay}
                    handleMediaCollection={this.handleMediaCollection}
                    handlePendingUpload={this.handlePendingUpload}
                    isCandleLit={this.state.isCandleLit}
                    isInferiorBrowser={this.props.isInferiorBrowser}
                    location={this.props.location}
                    mediaCollection={this.state.mediaCollection}
                    mobileDetails={this.props.mobileDetails}
                  />
                ) : null}
              </div>
              {allowGuestBook && allowGuestBookEntry ? (
                <Entry
                  condolenceError={this.state.condolenceError}
                  firstName={firstName}
                  handleCandleToggle={this.toggleCandleLighting}
                  handleDisplayError={this.handleDisplayError}
                  handleEditOverlay={this.openEditOverlay}
                  handleEntryToggle={this.handleEntryToggle}
                  handleMediaCollection={this.handleMediaCollection}
                  handleSubmit={this.handleCondolenceSubmission}
                  isCandleLit={this.state.isCandleLit}
                  isNFGB={_.get(
                    this.props,
                    'personStore.person.personLayout.isNFGB',
                    false
                  )}
                  isSubmitting={this.state.submittingCondolence}
                  lastName={lastName}
                  location={this.props.location}
                  mediaCollection={this.state.mediaCollection}
                  mutationStatus={_.get(
                    this.props,
                    'personStore.mutationStatus'
                  )}
                  ref={this.setRefEntry}
                  showCollection={!this.state.isInitialUpload}
                  sourceId={_.get(
                    this.props,
                    'personStore.person.guestBook.sourceId'
                  )}
                />
              ) : null}
              {_.size(edges) > 0 ? (
                <CondolenceCollection
                  adService={this.props.ads.adService}
                  data={edges}
                  getAdditionalPayload={_.partial(
                    this.getAdditionalPayload,
                    this.currentPage
                  )}
                  handleHubItemClick={this.handleModalOpen}
                  hasNextPage={hasNextPage}
                  isFetchingData={this.state.fetchingData}
                  isPhone={this.state.isPhone}
                  personPageType={personPageType}
                  primaryFuneralHome={this.props.primaryFuneralHome}
                  showFlowersAndGifts={_.get(
                    this.props,
                    'personStore.person.personLayout.showFlowersAndGifts'
                  )}
                  sourceId={_.get(
                    this.props,
                    'personStore.person.guestBook.sourceId'
                  )}
                />
              ) : null}
              {preloaderContainer}
              {guestBookFooterBtn}
            </div>
          </div>
          {modal}
        </div>
      );
    }
    return (
      <div>
        <ErrorDisplay isFallback={isFallback} />
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ads: state.adStore,
  personStore: _.get(state, 'personStore'),
  mobileDetails: state.mobileDetailsStore,
});
const mapDispatchToProps = dispatch => ({
  queryCondolences: queryParams => {
    dispatch(queryCondolences(queryParams));
  },
  queryGalleryCondolences: queryParams => {
    dispatch(queryGalleryCondolences(queryParams));
  },
  mutateCondolence: mutationParams => {
    dispatch(mutateCondolence(mutationParams));
  },
  mutatePersonAlert: mutationParams => {
    dispatch(mutatePersonAlert(mutationParams));
  },
  resetMutationStatus: mutationStatus => {
    dispatch(resetCondlenceMutationStatus(mutationStatus));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  {withRef: true}
)(GuestBook);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/GuestBook/GuestBook.js